<template>
    <div>
        <iframe v-if="isInIframe" :src="pageUrlWithActivityQuery" class="test-iframe" frameborder="0"></iframe>
        <div v-else class="game" :style="{
        '--player-color-main': getTaskAuthorColor() || getPlayerColor(playerId)
    }" :class="currentGame || !gameStarted ? layoutType : sandboxLayoutType">
            <PageSmallWindowResolution v-show="isSmallWindowSize"></PageSmallWindowResolution>
            <page-loader v-if="pageLoaderIsVisible && !loaderIsNotVisible" @close="closePageLoader"></page-loader>
            <template v-show="!isSmallWindowSize">
                <portal-target name="modalPortal"></portal-target>
                <div class="error-container js-error-container" style="
            position: fixed;
            z-index: 4;
            top: 0;
            left: 0;
            right: 0;
        "></div>

                <div v-if="connectionError" style="
            position: fixed;
            z-index: 1;
            top: 0;
            left: 0;
            right: 0;
            padding: 10px;
            color: #fff;
            background: blue;
        ">
                    {{connectionError}}
                    <button v-if="!isConnectedToGameServer" type="button" @click="reload">
                        {{ $t('modals.press_to_reconnect') }}
                    </button>
                </div>

                <Header ref="header"
                        :table-is-on="tableOn"
                        :game-restrictions="gameRestrictions"
                        :interface-guide-images="interfaceGuideImages"
                        :layout-type="layoutType"
                        @show-guide="showGuide"
                        @change-table-visibility="toggleTableVisibility"
                        @show-bug-report="showBugReportForm"
                        @show-freeze-room-modal="showFreezeRoomModal"
                        @show-change-room-url-modal="showChangeRoomUrlModal"
                        @show-rules="showRules"
                        @toggle-dice="toggleDiceVisibility"
                        @show-settings-modal="openSettingsModal"
                        @send-message="sendMessage">
                </Header>
                <RestartWithNewPlayerModal
                    v-if="restartWithNewPlayerModalIsVisible"
                    :player-left="playerLeft"
                    @close="closeRestartWithNewPlayerModal"
                    @restart="sendMessage">
                </RestartWithNewPlayerModal>
<!--                <SuggestModal v-if="suggestGameIsVisible && suggestModalData"
                              :data="suggestModalData"
                              @close="closeSuggestModal">
                </SuggestModal>-->
                <div class="game__rules-modal" v-if="gameRulesVisible && currentGame.rules_image"
                     @click="hideRules">
                    <img :src="currentGame.rules_image">
                </div>
                <slider-modal v-if="guideIsVisible && interfaceGuideImages && interfaceGuideImages.length"
                              :images="interfaceGuideImages"
                              @close="hideGuide">
                </slider-modal>

                <div class="game__room">
                    <not-chrome-alert v-if="!isChrome"></not-chrome-alert>
                    <div class="game-init" v-if="!gameStarted && isMobileTaskVisible" ref="gameInit">

                        <game-preset v-if="presetIsVisible" ref="mainPreset"></game-preset>
                        <game-welcome></game-welcome>
                    </div>

                    <game-tasks-container
                        v-if="gameStarted"
                        ref="taskContainer"
                        :table-on="tableOn"
                        :layout-type="layoutType"
                        :table-hand-instance="tableHandInstance"
                        :isMobileTaskVisible="isMobileTaskVisible"
                        :processTaskUrl="processTaskUrl"
                        :gameState="gameState"
                        :uploadCardsUrl="uploadCardsUrl"
                        :uploadBackgroundUrl="uploadBackgroundUrl"
                        :game-restrictions="gameRestrictions"
                        @refresh-task-container="refreshTaskContainer"
                    ></game-tasks-container>

                    <game-conference v-if="conferenceIsAllowed !== null" ref="conference"
                                     :game-hash="gameHash"
                                     :player-id="playerId"
                                     :is-join-modal-visible="joinModalIsVisible"
                                     @close-join-modal="closeJoinModal"
                                     @close-settings-modal="closeSettingsModal"
                                     @open-join-modal="openJoinModal"
                                     :game-restrictions="gameRestrictions"
                                     :settings-modal-is-visible="settingsModalIsVisible">
                    </game-conference>

                    <game-chat
                        ref="chat"
                        :player-id="playerId"
                        :isMobileChatVisible="isMobileChatVisible"
                        :isDiceVisible="isDiceVisible"
                    ></game-chat>

                </div>

                <div class="game__panel-bottom">
                    <div class="icon"
                         :class="{'active': isMobileTaskVisible}"
                         @click="setMobilePanelsVisibility(1,0,0)">
                        <svg><use xlink:href="#ic_star"></use></svg>
                    </div>
                    <div class="icon"
                         :class="{'active': isMobilePlayersVisible}"
                         @click="setMobilePanelsVisibility(0,1,0)">
                        <svg><use xlink:href="#ic_group"></use></svg>
                    </div>
                    <div class="icon"
                         :class="{'active': isMobileChatVisible}"
                         @click="setMobilePanelsVisibility(0,0,1)">
                        <svg><use xlink:href="#ic_message"></use></svg>
                    </div>
                </div>

                <dice-roll v-if="showDiceAnimation"
                           :values="diceAnimationValues" :color="diceAnimationColor">
                </dice-roll>

                <sounds-manager ref="sounds"></sounds-manager>

                <notifications-manager v-if="notification"
                                       :notification="notification"
                                       @close="closeNotification">
                </notifications-manager>

                <freeze-room-modal
                    v-if="freezeRoomModalVisible"
                    :game-id="gameHash"
                    @close="hideFreezeRoomModal"
                ></freeze-room-modal>

                <change-room-url-modal
                    v-if="changeRoomUrlModalVisible"
                    :game-id="gameHash"
                    @close="hideChangeRoomUrlRoomModal"
                ></change-room-url-modal>

                <div class="connector-stage" id="connectorStage"></div>
                <game-zoom-container></game-zoom-container>
                <bug-report-form
                    v-if="bugReportFormVisible"
                    @close="hideBugReportForm"
                    :create-report-url="createReportUrl"
                    :game-id="gameHash"
                    :player-id="playerId"
                >
                </bug-report-form>
            </template>
        </div>
    </div>
</template>

<script>
    import store from "../store";
    import ErrorHandler from "../helpers/ErrorHandler";
    import Tools from "../helpers/Tools";
    import KeyboardEventsObserver from "../services/KeyboardEventsObserver";
    import EventApi from "../api/EventsApi";
    import ChangeRoomUrlModal from "./Modal/ChangeRoomUrlModal";
    import GameCatalog from "./GameCatalog/GameCatalog";
    import TakeSeatModal from "./Modal/TakeSeatModal";
    import PageSmallWindowResolution from "./PageSmallWindowResolution";
    import SettingsModal from "./Modal/SettingsModal"
    import {Tool} from "../helpers/Tool";
    import NotChromeAlert from "./Widgets/NotChromeAlert";
    import SliderModal from "./Modal/SliderModal";
    import RestartWithNewPlayerModal from "./Modal/RestartWithNewPlayerModal";
    import NotificationsManager from "./Managers/NotificationsManager";
    import SoundsManager from "./Managers/SoundsManager";
    import PageLoader from "./Widgets/PageLoader";
    import GameConference from "./Conference/GameConference";
    import SuggestModal from "./Modal/SuggestModal";

    const TYPE_INIT = 'init';
    const TYPE_INIT_COMPLETE = 'initComplete';
    const TYPE_CHAT_MESSAGE = 'chatMessage';
    const TYPE_VIDEO_DATA = 'videoData';
    const TYPE_CHAT_HISTORY = 'chatHistory';
    const TYPE_CHAT_UPDATED = 'chatUpdated';
    const TYPE_REQUEST_CHAT_HISTORY = 'requestChatHistory';
    const TYPE_UPDATE_MESSAGE = 'updateMessage';
    const TYPE_TOGGLE_MESSAGE_VISIBILITY = 'toggleMessageVisibility';
    const TYPE_ACTIVITIES_LIST = 'activitiesList';
    const TYPE_CONTENT_PACK_TASKS = 'contentPackTasks';
    const TYPE_CONTENT_PACK = 'contentPack';
    const TYPE_GAME_IS_EXPIRED = 'gameIsExpired';
    const TYPE_GAME_IS_FROZEN = 'gameIsFrozen';
    const TYPE_GAME_URL_IS_CHANGED = 'gameUrlIsChanged';
    const TYPE_REACTION = 'reaction';
    const TYPE_PLAY_SOUND = 'playSound';
    const TYPE_SHOW_NOTIFICATION = 'showNotification';
    const TYPE_GAME_FIELD = 'gameField';
    const TYPE_GET_GAME_FIELD = 'getGameField';
    const TYPE_ACCESS_RIGHTS = 'accessRights';
    const TYPE_SAVE_FIELD_SUCCESS = 'saveFieldSuccess';
    const TYPE_DIFF = 'diff';
    const TYPE_PLAYER_VIDEO = 'playerVideo';
    const TYPE_PLAYER_VIDEO_AUTOMATION = 'playerVideoAutomation';
    const TYPE_ACTIVITY_STARTED = 'activityStarted';
    const TYPE_ACTIVITY_STARTING = 'activityStarting';
    const TYPE_ITEM_MOVED_TO_TABLE = 'itemMovedToTable';
    const TYPE_RESET_VIDEO_CONFERENCE = 'playerVideoReset';
    const TYPE_ITEM_SENDED = 'itemSended';
    const TYPE_ITEM_RECEIVED = 'itemReceived';
    const TYPE_FILTERS_LIST = 'filtersList';
    const TYPE_SHOW_SUGGESTED_TASK = 'showSuggestedTask';
    const TYPE_INTERFACE_GUIDE = 'interfaceGuide';
    const TYPE_NOTIFICATION_ACTIVITY = 'activityNotification';
    const TYPE_GET_CONFERENCE_USER = 'getConferenceUser';
    const TYPE_CONFERENCE_USER = 'conferenceUser';
    const TYPE_CONFERENCE_USER_TOKEN = 'conferenceUserToken';
    const TYPE_ACTIVITY_PROCESS_ERROR = 'activityProcessError';
    const TYPE_START_INTRO = 'introStarting';
    const TYPE_TOGGLE_HAND = 'switchPlayerHand';
    const TYPE_SHOW_RESTART_ACTIVITY_MODAL = 'showRestartActivityModal';
    const TYPE_START_ACTIVITY_REQUEST = 'startActivityRequest';
    const TYPE_PLAYER_REJECT_GAME = 'playerRejectedGame';
    const JSON_PATCH = 'patch';

    const TASK_STATE_TYPE_PRESET = 1;
    const TASK_STATE_TYPE_CUSTOM = 2;

    const TASK_VISIBILITY = {
        HIDDEN: 0,
        VISIBLE: 1,
        VISIBLE_FOR: 2,
    };

    const TASK_TYPES = ['main', 'additional'];
    const EVENT_SEND_MESSAGE = 'sendMessage';
    const ZONE_TYPE_TASKS = 1;
    const ZONE_TYPE_FIELD = 2;

    export default {
        components: {
            SuggestModal,
            RestartWithNewPlayerModal,
            GameConference,
            PageLoader,
            SoundsManager,
            NotificationsManager,
            SliderModal,
            NotChromeAlert,
            TakeSeatModal,
            GameCatalog,
            ChangeRoomUrlModal,
            PageSmallWindowResolution,
            SettingsModal},
        props: {
            websocketUrl: {
                required: true,
                type: String
            },
            voximplantUrl: {
                required: true,
                type: String
            },
            gameHash: {
                required: true,
                type: String
            },
            playerId: {
                required: true,
                type: String
            },
            processTaskUrl: {
                required: true,
                type: String
            },
            expiredUrl: {
                required: true,
                type: String
            },
            defaultActivityId: {
                type: String,
                default: null,
            },
            language: {
                required: true,
                type: String
            },
            uploadCardsUrl: {
                required: true,
                type: String
            },
            createReportUrl: {
                required: true,
                type: String
            },
            uploadBackgroundUrl: {
                required: true,
                type: String,
            },
            videoProvider: {
                required: true,
                type: String
            },
            hideConference: {
                required: true,
                type: String
            },
            mini: {
                required: true,
                type: String
            },
            subscribeUrl: {
                required: true,
                type: String
            }
        },

        data() {
            return {
                pageLoaderIsVisible: true,
                connection: null,
                isConnectedToGameServer: false,
                connectionError: null,
                pingTimerId: null,
                isChatLoaded: false,
                isChatVisible: true,
                isDiceVisible: false,
                isMobileSettingsVisible: false,
                isMobileTaskVisible: true,
                isMobilePlayersVisible: false,
                isMobileChatVisible: false,
                messages: [],
                taskSettings: {
                    main: {
                        visibility: null,
                        visibleFor: []
                    },
                    additional: {
                        visibility: null,
                        visibleFor: []
                    }
                },
                timers: {},

                TASK_VISIBILITY: TASK_VISIBILITY,
                taskFormVisible: false,
                taskFormType: '',
                isDeviceMenuVisible: false,
                isCustomGame: false,
                gameStarted: false,
                previouslyShownTasks: {},
                showDiceAnimation: false,
                diceAnimationValues: [],
                diceAnimationColor: null,
                likeIsClicked: false,
                likeIsClickedColor: '',
                gameRulesVisible: false,
                guideIsVisible: false,
                canUpdateGameField: true,
                currentActivitiesLength: 1,
                helpVisible: false,
                bugReportFormVisible: false,
                freezeRoomModalVisible: false,
                changeRoomUrlModalVisible: false,
                keyboardEventsObserver: null,
                gameRestrictions: {
                    lifetime: 0,
                    activeTime: {
                        total: 0,
                        used: 0,
                    }
                },
                tableOn: false,
                tableHandInstance: {},
                joinModalIsVisible: false,
                settingsModalIsVisible: false,
                presetIsVisible: false,
                windowWidth: 1920,
                interfaceGuideImages: null,
                notification: null,
                sandboxLayoutType: 'default-layout',
                isInIframe: false,
                restartWithNewPlayerModalIsVisible: false,
                playerLeft: false,
                suggestGameIsVisible: false,
                suggestModalData: null,
            }
        },

        created() {
            const pageUrl = window.location.href;
            const url = new URL(pageUrl);
            this.isInIframe = !!url.searchParams.get('inFrame');
        },

        mounted() {
            store.dispatch('setConferenceIsAllowed', !JSON.parse(this.hideConference));
            store.dispatch('setIsMini', JSON.parse(this.mini));
            store.dispatch('setSubscribeUrl', this.subscribeUrl);
            if (this.conferenceIsAllowed) {
                this.$conferenceManager.changeProvider(this.videoProvider);
            }

            this.connectToServer();

            if (this.isMobile) {
                this.isMobileTaskVisible = false;
                this.isMobileChatVisible = false;
                this.isMobilePlayersVisible = true;
            }

            this.bindEvents();

            this.keyboardEventsObserver = new KeyboardEventsObserver();
            this.windowWidth = window.innerWidth;

            window.addEventListener('resize', () => {
                this.$nextTick(() => {
                    this.windowWidth = window.innerWidth;
                });
            });

            this.checkTableIsOpened();
        },

        beforeDestroy() {
            this.unbindEvents();
        },

        computed: {
            conferenceIsAllowed: function()
            {
                return store.getters.getConferenceIsAllowed;
            },
            gameState: function()
            {
                return store.getters.getGameState;
            },

            players: function()
            {
                return store.getters.getPlayers;
            },

            isChrome: function()
            {
                return Tool.getBrowserName() === 'Chrome';
            },

            isSmallWindowSize: function() {
                return this.windowWidth < 1200;
            },

            isRus: function() {
                return document.documentElement.lang === 'ru';
            },

            isMobile: function () {
                return Tools.deviceIsMobile();
            },

            /**
             * Текущая игра (активность)
             */
            currentGame: function () {
                const activities = store.getters.getActivitiesList;

                if (typeof activities !== 'undefined') {
                    for (let id in activities) {
                        if (activities.hasOwnProperty(id)) {
                            let activity = activities[id];

                            if (parseInt(activity.id) !== this.gameState.tasks.state.activity_id) {
                                continue;
                            }

                            return activities[id];
                        }
                    }
                }

                return null;
            },

            /**
             * Текущее состояние стола-руки
             */
            currentGameField: function () {
                return store.getters.getGameField;
            },

            gameZoneType: function() {
                return this.gameState.tasks.state.zone_type;
            },

            /**
             * Фильтры каталога игр по типу
             */
            typesCatalogFilters: function () {
                return store.getters.getTypesCatalogFilters;
            },
            /**
             * Фильтры каталога игр по геймплею
             */
            gameplayCatalogFilters: function () {
                return store.getters.getTypesCatalogFilters;
            },

            /**
             * Тип лейаута, определяется настройками игры
             * @returns {any}
             */
            layoutType: function() {
                return store.getters.getCurrentLayoutType;
            },

            loaderIsNotVisible: function () {
                const params = new URLSearchParams(window.location.search);
                return params.has('loader-false');
            },

            pageUrlWithActivityQuery: function () {
                const pageUrl = window.location.href;
                const url = new URL(pageUrl);

                return url.pathname + '?' + url.searchParams.get('activityId');
            }
        },

        methods: {

            closePageLoader()
            {
                this.pageLoaderIsVisible = false;
            },

            closeNotification()
            {
                this.notification = null;
            },

            closeRestartWithNewPlayerModal()
            {
                this.restartWithNewPlayerModalIsVisible = false;
            },

            closeSuggestModal()
            {
                this.suggestGameIsVisible = false;
            },

            /**
             * Проверить, открываем ли стол
             * @private
             */
            checkTableIsOpened()
            {
                const timer = setInterval(() => {
                    if (this.gameState.tasks
                        && this.gameZoneType) {
                        clearInterval(timer);
                        this.tableOn = this.gameZoneType === 2;
                    }
                }, 100);
            },

            openJoinModal()
            {
                this.joinModalIsVisible = true;
            },

            closeJoinModal(saveSettings = false)
            {
                this.joinModalIsVisible = false;

                if (!saveSettings) {
                    this.$conferenceManager.videoManager.closeSettings();
                }
            },
            openSettingsModal()
            {
                this.settingsModalIsVisible = true;
            },

            closeSettingsModal(saveSettings = false)
            {
                this.settingsModalIsVisible = false;

                if (!saveSettings) {
                    this.$conferenceManager.videoManager.closeSettings();
                }
            },
            refreshTaskContainer()
            {
                this.tableOn = false;
            },

            /**
             * Переключить видимость стола
             */
            toggleTableVisibility(value)
            {
                this.tableOn = value;

                if (this.isCustomGame) { //В кастомной игре зона заданий\стола должна переключаться у всех
                    this.sendMessage('changeZoneType', {
                        zoneType: value === true ? ZONE_TYPE_FIELD : ZONE_TYPE_TASKS
                    });
                }
            },

            /**
             * Показать bug report
             */
            showBugReportForm()
            {
                this.bugReportFormVisible = true;
            },

            /**
             * Скрыть bug report
             */
            hideBugReportForm()
            {
                this.bugReportFormVisible = false;
            },

            //TODO delete after reskin
            /**
             * Показать/скрыть справку
             */
            toggleHelp()
            {
                this.helpVisible = !this.helpVisible;
            },

            /**
             * скрыть справку
             */
            closeHelp()
            {
                this.helpVisible = false;
            },

            /**
             * Показать правила игры
             */
            showRules()
            {
                this.gameRulesVisible = true;
            },

            /**
             * Скрыть правила игры
             */
            hideRules()
            {
                this.gameRulesVisible = false;
            },

            /**
             * Показать правила игры
             */
            showGuide()
            {
                this.guideIsVisible = true;
            },

            /**
             * Скрыть правила игры
             */
            hideGuide()
            {
                this.guideIsVisible = false;
            },

            /**
             *Подсветить кнопку лайков при БЗЗЗЗЗ
             */
            highlightLikesControl(color)
            {
                this.likeIsClickedColor = color;
                this.likeIsClicked = true;
                setTimeout(() => {
                    this.likeIsClicked = false;
                    this.likeIsClickedColor = '';
                }, 1500);
            },

            /**
             * Соединиться с игровым сервером
             */
            connectToServer()
            {
                this.connectionError = null;
                this.connection = new WebSocket(this.websocketUrl);
                this.connection.onmessage = (e) => this.onMessage(e);
                this.connection.onopen = () => this.onOpen();
                this.connection.onclose = () => {
                    this.$conferenceManager.videoManager.disconnect();
                    this.isConnectedToGameServer = false;
                    this.connectionError = this.$t('modals.connection_problem');
                }
            },

            /**
             * Получение сообщения
             * @param e
             */
            onMessage(e)
            {
                if (this.isSmallWindowSize) {
                    return;
                }
                this.parseMessage(e.data);
            },

            /**
             * Открытие соединиения
             */
            onOpen()
            {
                this.isConnectedToGameServer = true;
                const data = {
                    userId: this.playerId,
                    localStorageData: JSON.stringify(localStorage),
                    language: this.language,
                };
                this.sendMessage(TYPE_INIT, data);

                store.commit('setPlayerId', this.playerId);
            },

            /**
             * Отправка сообщения
             */
            sendMessage(type, data)
            {
                this.connection.send(JSON.stringify({
                    type: type,
                    gameId: this.gameHash,
                    data: data
                }));
            },

            /**
             * Обработка полученного сообщения
             * @param rawMessage
             */
            parseMessage(rawMessage) {
                const message = JSON.parse(rawMessage);
                const data = message.data;

                if (message.type === TYPE_GAME_IS_EXPIRED) {
                    window.location.href = this.expiredUrl;
                }

                if (message.type === TYPE_GAME_IS_FROZEN) {
                    window.location.reload();
                }

                if (message.type === TYPE_GAME_URL_IS_CHANGED) {
                    window.location.reload();
                }

                if (message.type === TYPE_INIT_COMPLETE) {
                    this.$refs.chat.clearLastLoadedMessageId();
                    this.$refs.chat.requestChatHistoryMessage();
                    this.sendMessage('getActivitiesList', {});
                    this.sendMessage(TYPE_GET_GAME_FIELD, {});
                    this.sendMessage(TYPE_GET_CONFERENCE_USER, {});

                    if (this.$conferenceManager.videoManager.isAgora()) {
                        EventApi.triggerEvent(EventApi.VIDEO_CONFERENCE_READY);
                    }
                }

                //Получение сообщений только после загрузки истории чата
                if (message.type === TYPE_CHAT_MESSAGE && this.isChatLoaded) {
                    if (message.data.command === "/vote" && message.data.data.external) {
                        EventApi.triggerEvent(EventApi.START_EXTERNAL_VOTING, message.data);
                    } else {
                        this.$refs.chat.addMessageToChat(data);
                    }
                }

                // реакция игрока
                if (message.type === TYPE_REACTION) {
                    this.$refs.header.processReaction(data);
                    this.highlightLikesControl(this.getPlayerColor(data.userId));
                }

                if (message.type === TYPE_RESET_VIDEO_CONFERENCE) {
                    EventApi.triggerEvent(EventApi.REINIT_CONFERENCE);
                }

                if (message.type === 'gameState') {
                    this.gameRestrictions = data.restrictions;

                    store.commit('setPlayers', data.players);
                    store.commit('setGameState', data.state);
                    window.PixiScene?.gameStateHandler(data.state);

                    this.$refs.conference.updateSeatsMap();

                    TASK_TYPES.forEach((type) => {
                        Vue.nextTick(() => {
                            if (this.$refs.taskContainer) {
                                this.$refs.taskContainer.syncTaskSettings(type);
                            }
                        });
                    });

                    if (this.$refs.taskContainer) {
                        this.$refs.taskContainer.showTimer(this.gameState.timer, this.gameState.time);
                    }


                    this.$refs.conference.changePlayersData();

                    this.gameStarted = this.gameState.tasks.state.game_started;

                    if (this.gameStarted) {
                        this.presetIsVisible = false;
                    }

                    this.isCustomGame = this.gameState.tasks.state.type === TASK_STATE_TYPE_CUSTOM;

                    if (this.isCustomGame && this.gameState.tasks && this.gameState.tasks.state.zone_type) {
                        this.tableOn = this.gameState.tasks.state.zone_type === ZONE_TYPE_FIELD;
                    }

                    this.addSetToLocalStorage();
                }

                if (message.type === 'error') {
                    ErrorHandler.error(data.message);
                }

                if (message.type === TYPE_CHAT_HISTORY) {
                    this.$refs.chat.addChatHistory(data);
                    this.isChatLoaded = true;
                }

                if (message.type === TYPE_CHAT_UPDATED) {
                    this.$refs.chat.cleanChatHistory();
                    this.$refs.chat.requestChatHistoryMessage();
                    this.isChatLoaded = true;
                }

                if (message.type === TYPE_UPDATE_MESSAGE) {
                    if (data.message.command === "/voteres" && data.message.data.external) {
                        EventApi.triggerEvent(EventApi.SHOW_EXTERNAL_VOTE_RESULT, data.message);
                    } else {
                        this.$refs.chat.updateMessage(data);
                    }
                }

                if (message.type === TYPE_TOGGLE_MESSAGE_VISIBILITY) {
                    this.$refs.chat.toggleMessageVisibility(data);
                }

                if (message.type === TYPE_ACTIVITIES_LIST) {
                    store.commit('setActivitiesList', data.activitiesList);
                }

                if (message.type === TYPE_PLAY_SOUND) {
                    EventApi.triggerEvent(EventApi.START_SOUND, data);
                }

                if (message.type === TYPE_ACCESS_RIGHTS) {
                    store.commit('setAccessRights', data);

                    if (data.is_admin) {
                        this.isChatVisible = false;
                    }
                }

                if (message.type === TYPE_GAME_FIELD && message.data.field) {
                    const refreshGameField = () => store.dispatch('setGameField', data.field);
                    refreshGameField();
                    if (window.PixiScene?.gameFieldHandler) {
                        window.PixiScene?.gameFieldHandler(message.data.field);
                    } else {
                        console.warn("GAME FIELD EARLIER THAN STAGE CREATED");
                    }
                }

                if(message.type == JSON_PATCH){
                    //window.PixiScene?.applyJsonPatch && window.PixiScene?.applyJsonPatch(message.data);
                }

                if (message.type === TYPE_ACTIVITY_PROCESS_ERROR) {
                    window.PixiScene?.errorHandler(message.type);
                }

                if (message.type === TYPE_DIFF) {
                    const operations = message.data.map((el) => el.operation);
                    const isOperation = op => operations.includes(op);
                    if (isOperation('clearField')) {
                        EventApi.triggerEvent(EventApi.EDIT_BREAK);
                        EventApi.triggerEvent(EventApi.RESET_AUDIO_THEME);
                        EventApi.triggerEvent(EventApi.SHOW_VIDEO);
                    }
                    if (isOperation('deleteStack')) {
                        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'delete'});
                    }
                    if (isOperation('changePlayerCardsCount')) {
                        const field = store.getters.getGameField;
                        const data = message.data.filter(el => el.operation === 'changePlayerCardsCount');
                        data.forEach((el) => {
                            const value = el.value;
                            field.players[value.playerId].cardsCount = value.count;
                            store.dispatch('setGameField', field);
                        });
                    }
                    window.PixiScene?.diffHandler && window.PixiScene?.diffHandler(message.data);
                }

                if (message.type === TYPE_SAVE_FIELD_SUCCESS) {
                    alert('Игровое поле успешно сохранено');
                }

                if (message.type === TYPE_PLAYER_VIDEO) {
                    if (message.data.cameraStatus !== null) {
                        this.$refs.conference.setCameraStatus(message.data.cameraStatus);
                    }

                    if (message.data.microphoneStatus !== null) {
                        this.$refs.conference.setMicrophoneStatus(message.data.microphoneStatus);
                    }

                    if (message.data.audioStatus !== null) {
                        this.$refs.conference.setAudioStatus(message.data.audioStatus);
                    }
                }

                if (message.type === TYPE_PLAYER_VIDEO_AUTOMATION) {
                    const camStatus = message.data.cameraStatus;
                    const micStatus = message.data.microphoneStatus;
                    if (camStatus !== null) {
                        camStatus ? EventApi.triggerEvent(EventApi.SHOW_VIDEO) : EventApi.triggerEvent(EventApi.HIDE_VIDEO);
                    }
                    if (micStatus !== null) {
                        this.$refs.conference.setMicrophoneStatus(micStatus);
                    }
                }

                if (message.type === TYPE_ACTIVITY_STARTED) {
                    EventApi.triggerEvent(EventApi.SHOW_VIDEO);
                    EventApi.triggerEvent(EventApi.REFRESH_CHAT);
                    this.gameState.tasks.state.activity && EventApi.triggerEvent(EventApi.UPDATE_SEATS_ON_TABLE, this.gameState.tasks.state.activity.settings.layoutType);
                    if (this.gameState.tasks && this.gameState.tasks.state.zone_type) {
                        this.tableOn = this.gameState.tasks.state.zone_type === ZONE_TYPE_FIELD;
                    }
                }

                if (message.type === TYPE_ACTIVITY_STARTING) {
                    EventApi.triggerEvent(EventApi.RESET_AUDIO_THEME);
                    EventApi.triggerEvent(EventApi.RESET_GAME);
                    this.showPageLoader();
                }

                if (message.type === TYPE_FILTERS_LIST) {
                    const TYPE_TYPE_FILTER = 1;
                    const TYPE_GAMEPLAY_FILTER = 2;
                    const allFilters = message.data.filters;

                    let typesFilters = [];
                    let gameplayFilters = [];

                    allFilters.forEach(filter => {
                        if (Number(filter.type) === TYPE_TYPE_FILTER) {
                            typesFilters.push(filter);
                        }
                        if (Number(filter.type) === TYPE_GAMEPLAY_FILTER) {
                            gameplayFilters.push(filter);
                        }
                    });

                    if (this.typesCatalogFilters) {
                        store.dispatch('setTypesCatalogFilters', null);
                    }
                    if (this.gameplayCatalogFilters) {
                        store.dispatch('setGameplayCatalogFilters', null);
                    }

                    typesFilters.unshift({
                        id: 0,
                        type: TYPE_TYPE_FILTER,
                        name: this.$t('message.all')
                    });

                    gameplayFilters.unshift({
                        id: 0,
                        type: TYPE_GAMEPLAY_FILTER,
                        name: this.$t('message.all')
                    });

                    typesFilters.forEach((item, index) => {
                        item.isActive = index === 0;
                    });
                    gameplayFilters.forEach((item, index) => {
                        item.isActive = index === 0;
                    });
                    store.dispatch('setTypesCatalogFilters', typesFilters);
                    store.dispatch('setGameplayCatalogFilters', gameplayFilters);
                }

                if (message.type === TYPE_SHOW_SUGGESTED_TASK) {
                    this.presetIsVisible = true;
                    Vue.nextTick(() => {
                        EventApi.triggerEvent(EventApi.SHOW_SUGGESTED_TASK, message.data);
                    });
                }

                if (message.type === TYPE_INTERFACE_GUIDE) {
                    this.interfaceGuideImages = message.data.images
                }

                if (message.type === TYPE_NOTIFICATION_ACTIVITY) {
                    this.notification = message;
                }

                if (message.type === TYPE_CONFERENCE_USER) {
                    if (!message.data.user) {
                        console.error('Error getting video conferencing user');
                    }

                    this.$conferenceManager.videoManager.init(message.data.user);
                }

                if (message.type === TYPE_CONFERENCE_USER_TOKEN) {
                    EventApi.triggerEvent(EventApi.LOGIN_WITH_TOKEN,{
                        'token' : message.data.token,
                    });
                }

                if (message.type === TYPE_START_INTRO && message.data.introStarting) {
                    EventApi.triggerEvent(EventApi.START_INTRO);
                }

                if (message.type === TYPE_TOGGLE_HAND) {
                    EventApi.triggerEvent(EventApi.CHANGE_HAND_VISIBILITY, message.data.visible);
                }

                if (message.type === TYPE_SHOW_RESTART_ACTIVITY_MODAL &&
                    message.data.playerId !== this.playerId &&
                    this.currentGame) {
                    this.restartWithNewPlayerModalIsVisible = true;
                    const player = store.getters.getPlayerDataById(message.data.playerId);
                    if (!player) {
                        this.playerLeft = true;
                    } else {
                        this.playerLeft = player.isGuest;
                    }
                }

                if (message.type === TYPE_START_ACTIVITY_REQUEST) {
                    this.suggestGameIsVisible = true;
                    this.suggestModalData = {
                        playerId: message.data.playerId,
                        activityId: message.data.activityId
                    };
                }

                if (message.type === TYPE_PLAYER_REJECT_GAME) {
                    this.closeSuggestModal();
                }
            },

            /**
             * Переключить видимость чата
             */
            toggleChatVisibility()
            {
                this.isChatVisible = !this.isChatVisible;
            },

            /**
             * Переключить видимость дайсомета
             */
            toggleDiceVisibility()
            {
                this.isDiceVisible = !this.isDiceVisible;
            },

            /**
             * Переключить видимость кнопок устройств на мобильном
             */
            toggleMobileSettingsVisibility()
            {
                this.isMobileSettingsVisible = !this.isMobileSettingsVisible;
            },

            /**
             * Переключить видимость кнопок устройств на мобильном
             */
            setMobilePanelsVisibility(taskVisibility, playersVisibility, chatVisibility)
            {
                this.isMobileTaskVisible = !!taskVisibility;
                this.isMobilePlayersVisible = !!playersVisibility;
                this.isMobileChatVisible = !!chatVisibility;
            },

            /**
             * Показать лоадер страницы
             */
            showPageLoader ()
            {
                this.pageLoaderIsVisible = true;
            },

            /**
             * Найти игрока по id
             * @param playerId
             * @return {*}
             */
            findPlayer(playerId)
            {
                let result = null;
                this.players.forEach((player) => {
                    if (player.id === playerId) {
                        result = player;
                    }
                });
                return result;
            },

            /**
             * Цвет игрока по id
             * @param playerId
             * @return {null|*}
             */
            getPlayerColor(playerId)
            {
                const player = this.findPlayer(playerId);
                if (!player) {
                    return null;
                }

                return player.color.code;
            },

            getPlayerColorContrast(playerId) {
                const player = this.findPlayer(playerId);
                if (!player) {
                    return null;
                }

                return player.color.contrast;
            },

            /**
             * Изменить статус звука
             */
            changeAudioStatus()
            {
                this.$refs.conference.changeAudioStatus();
            },

            /**
             * Цвет автора последней задачи
             */
            getTaskAuthorColor()
            {
                const mainTaskAuthor = this.gameState.tasks.main.author;
                const additionalTaskAuthor = this.gameState.tasks.additional.author;

                if (!mainTaskAuthor && !additionalTaskAuthor) {
                    return null;
                }

                let authorId = null;
                if (!mainTaskAuthor || !additionalTaskAuthor) {
                    authorId = mainTaskAuthor || additionalTaskAuthor;
                } else {
                    if (this.gameState.tasks.main.updated_at > this.gameState.tasks.additional.updated_at) {
                        authorId = mainTaskAuthor;
                    } else {
                        authorId = additionalTaskAuthor;
                    }
                }

                return this.getPlayerColor(authorId);
            },

            /**
             * Название выбранной игры
             * @return {string|*}
             */
            getSelectedGameName()
            {
                if (this.gameState.tasks.state.type === TASK_STATE_TYPE_CUSTOM) {
                    return this.$t('message.custom_game');
                }

                if (store.getters.getCurrentActivity) {
                    return store.getters.getCurrentActivity.name;
                }

                return this.$t('message.choose_game');
            },

            /**
             * Добавить сет заданий в localStorage
             *
             * Нужен для того, чтобы заного не показывать игрокам задания
             * при включенной опции в игре "стараться без повторов"
             */
            addSetToLocalStorage()
            {
                if (typeof localStorage.previouslyShownTasks === 'undefined') {
                    this.previouslyShownTasks = {};
                } else {
                    this.previouslyShownTasks = JSON.parse(localStorage.previouslyShownTasks);
                }

                if (this.gameState.tasks.state.game_started) {

                    let contentPackId = this.gameState.tasks.state.content_pack_id;
                    let setId = this.gameState.tasks.state.current_set_id;

                    if (typeof this.previouslyShownTasks[contentPackId] === 'undefined') {
                        this.previouslyShownTasks[contentPackId] = [];
                    }

                    if (this.previouslyShownTasks[contentPackId].indexOf(setId) === -1) {
                        this.previouslyShownTasks[contentPackId].push(setId);
                    }
                }

                localStorage.previouslyShownTasks = JSON.stringify(this.previouslyShownTasks);
            },

            /**
             * Начать анимацию броска кубиков
             */
            startDicesAnimation(e)
            {
                if (this.currentGame && !this.currentGame.settings.canViewDice) {
                    return;
                }
                this.showDiceAnimation = false;
                Vue.nextTick(() => {
                    this.diceAnimationValues = e.detail.values;
                    this.diceAnimationColor = e.detail.color;
                    this.showDiceAnimation = true;

                    Tools.runTimer('diceAnimationClose', () => {
                        this.showDiceAnimation = false;
                    }, 6000);
                });
            },

            bindEvents()
            {
                EventApi.addEventListener(EventApi.EVENT_START_DICES_ANIMATION, this.startDicesAnimation);
                EventApi.addEventListener(EventApi.EVENT_SEND_MESSAGE, this.sendMessageFromEvent);
                EventApi.addEventListener(EventApi.EVENT_DISABLE_PARSE_MESSAGES, this.disableParseMessages);
                EventApi.addEventListener(EventApi.EVENT_ENABLE_PARSE_MESSAGES, this.enableParseMessages);
                EventApi.addEventListener(EventApi.SHOW_PAGE_LOADER, this.showPageLoader);
                EventApi.addEventListener(EventApi.EVENT_CHANGE_LAYOUT, this.changeSandboxLayout);
            },

            unbindEvents()
            {
                EventApi.removeEventListener(EventApi.EVENT_START_DICES_ANIMATION, this.startDicesAnimation);
                EventApi.removeEventListener(EventApi.EVENT_SEND_MESSAGE, this.sendMessageFromEvent);
                EventApi.removeEventListener(EventApi.EVENT_DISABLE_PARSE_MESSAGES, this.disableParseMessages);
                EventApi.removeEventListener(EventApi.EVENT_ENABLE_PARSE_MESSAGES, this.enableParseMessages);
                EventApi.removeEventListener(EventApi.SHOW_PAGE_LOADER, this.showPageLoader);
                EventApi.removeEventListener(EventApi.EVENT_CHANGE_LAYOUT, this.changeSandboxLayout);
            },



            /**
             * Отправить сообщение из события
             * @param e
             */
            sendMessageFromEvent(e)
            {
                this.sendMessage(e.detail.type, e.detail.data);
            },

            /**
             * Карты в руке игрока
             * @param playerId
             * @returns {*[]|*}
             */
            getPlayerCards(playerId)
            {
                if (this.currentGameField === null || typeof this.currentGameField.players[playerId] === "undefined") {
                    return [];
                }

                return this.currentGameField.players[playerId].cards;
            },

            /**
             * Показать модальное окно заморозки комнаты
             */
            showFreezeRoomModal()
            {
                this.freezeRoomModalVisible = true;
            },

            /**
             * Скрыть модальное окно заморозки комнаты
             */
            hideFreezeRoomModal()
            {
                this.freezeRoomModalVisible = false;
            },

            /**
             * Показать модальное окно заморозки комнаты
             */
            showChangeRoomUrlModal()
            {
                this.changeRoomUrlModalVisible = true;
            },

            /**
             * Скрыть модальное окно заморозки комнаты
             */
            hideChangeRoomUrlRoomModal()
            {
                this.changeRoomUrlModalVisible = false;
            },

            /**
             * Отключение обработки входящих сообщений
             */
            disableParseMessages()
            {
                console.warn('Отключена обработка входящих websocket сообщений!');
                this.connection.onmessage = () => {};
            },

            /**
             * Включение обработки входящих сообщений
             */
            enableParseMessages()
            {
                console.warn('Включена обработка входящих websocket сообщений!');
                this.connection.onmessage = (e) => this.onMessage(e);
            },

            /**
             * Пререзагрузка страницы
             */
            reload()
            {
                window.location.reload();
            },

            /**
             *
             * @param e
             */
            changeSandboxLayout(e)
            {
                if (typeof e.detail !== 'undefined') {
                    this.sandboxLayoutType = e.detail;
                }
            }
        }
    }
</script>

<style scoped>
    .test-table {
        width: 100%;
    }
    .test-table tr {
        border-bottom: 1px solid #ccc;
    }

    .test-table td {
        padding: 15px 15px;
        border-left: 1px solid #ccc;
    }

    .error-container {
        display: none;
        padding: 20px;
        background: red;
        color: white;
        font-size: 18px;
        text-align: center;
    }

    .connector-stage {
        position: fixed;
        top: 0;
        left: 0;
    }

    .test-iframe {
        width: 100vw;
        height: 100vh;
    }
</style>
